export default __webpack_public_path__ + "static/media/Zone-6-Master-Plan-Type-G.6a5660d9.png";